/**
 * @module @yimoka/i18n/sync/hash
 * @summary 稳定 hash 用于变化检测
 * @author keep
 * @since 2026-05-19
 */

/**
 * 对对象做稳定 JSON 序列化后计算简单 hash。
 *
 * @param value - 任意可序列化值
 * @returns hash 字符串
 */
export function stableHash(value: unknown): string {
  const json = stableStringify(value);
  let hash = 0;
  for (let i = 0; i < json.length; i += 1) {
    hash = ((hash << 5) - hash + json.charCodeAt(i)) | 0;
  }
  return String(hash >>> 0);
}

/**
 * 键序无关的稳定 JSON 字符串。
 *
 * @param value - 待序列化值
 * @returns JSON 字符串
 */
function stableStringify(value: unknown): string {
  if (value === null || typeof value !== 'object') {
    return JSON.stringify(value);
  }

  if (Array.isArray(value)) {
    return `[${value.map(stableStringify).join(',')}]`;
  }

  const obj = value as Record<string, unknown>;
  const keys = Object.keys(obj).sort();
  const pairs = keys.map(key => `${JSON.stringify(key)}:${stableStringify(obj[key])}`);
  return `{${pairs.join(',')}}`;
}
